import axios from 'axios';
import Cookies from 'js-cookie';
import { rootAPI } from './api';

// Attribution only; retain each endpoint's existing Basic/Bearer Authorization.
export const installAuditIdentity = (client = axios, apiRoot = rootAPI) => client.interceptors.request.use(config => {
  try {
    const target = new URL(config.url, config.baseURL || window.location.origin);
    const api = new URL(apiRoot, window.location.origin);
    const prefix = `${api.pathname.replace(/\/$/, '')}/api/`;
    const token = Cookies.get('token');
    if (apiRoot && target.origin === api.origin && target.pathname.startsWith(prefix) && token) {
      config.headers = { ...config.headers, 'X-Audit-Token': `Bearer ${token}` };
    }
  } catch (_) { /* Attribution must not interrupt an existing request. */ }
  return config;
});
